import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect, useRef } from "react";
import CursorBlinker from "./CursorBlinker";

type Props = {
  baseText: string;
  duration: number;
  delay: number;
  repeat: number;
  backgroundColor: string;
  height: string;
  isCursorBlinker: boolean;
};

const TypingText = ({
  baseText,
  duration,
  delay,
  repeat,
  backgroundColor,
  height,
  isCursorBlinker,
}: Props) => {
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.round(latest));
  const displayText = useTransform(rounded, (latest) =>
    baseText.slice(0, latest)
  );
  useEffect(() => {
    const controls = animate(count, baseText.length, {
      type: "tween", // Not really needed because adding a duration will force "tween"
      duration: duration,
      delay: delay,
      ease: "linear",
      repeat: repeat,
    });
    return controls.stop;
  }, []);
  return (
    <>
      <motion.span>{displayText}</motion.span>
      {isCursorBlinker && (
        <CursorBlinker backgroundColor={backgroundColor} height={height} />
      )}
    </>
  );
};

export default TypingText;
